import {
  importRecipeFromUrl as coreImportRecipeFromUrl,
  normalizeUrl,
} from "@reciperoll/core";
import type { ImportResult } from "@reciperoll/core";
import { supabase } from "../lib/supabase";

export { normalizeUrl };
export type { ImportResult };

// Web binding for the shared URL import — injects the web Supabase client.
export function importRecipeFromUrl(
  url: string,
  recipeId?: string,
): Promise<ImportResult> {
  return coreImportRecipeFromUrl(supabase, url, recipeId);
}
